<template>
  <div class="flex-[4] rounded-lg overflow-hidden bg-gray-900 flex flex-col">
    <h1 class="text-text-primary p-6 text-xl font-semibold border-b-2 border-gray-950">
      {{ $t('profile.badges.title') }}
    </h1>

    <!-- Featured Badge -->
    <div class="w-full p-6 flex gap-4 relative border-b-2 border-gray-950">
      <div class="w-full absolute top-0 left-0 h-full z-20 topography-overlay" />
      <div class="w-full absolute top-0 left-0 h-full first-background z-10" />

      <img
        v-if="featuredBadge"
        :src="`/img/icons/${featuredBadge.name}_badge.svg`"
        class="h-24 w-24 min-w-[96px] z-50"
        :alt="$t('profile.badges.medal_alt')"
      />

      <div class="flex flex-col gap-2 justify-center z-50">
        <h1 class="text-text-primary text-medium">
          {{ formatBadgeName(featuredBadge?.name) }}
        </h1>
        <h2 class="text-text-secondary text-sm font-light">
          {{ featuredBadge?.description }}
        </h2>
      </div>
    </div>

    <!-- Additional Badges -->
    <div class="flex p-6 flex-wrap">
      <img
        v-for="badge in additionalBadges"
        :key="badge.id"
        :src="`/img/icons/${badge.name}_badge.svg`"
        class="h-16 w-16 min-w-[64px]"
        :alt="$t('profile.badges.medal_alt')"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  badges: {
    type: Array,
    default: () => [],
  },
});

const featuredBadge = computed(() => props.badges?.[0]);
const additionalBadges = computed(() => props.badges?.slice(1) || []);

function formatBadgeName(name) {
  if (!name) return '';
  return name.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
</script>

<style scoped>
.topography-overlay {
  background-image: url("../../assets/topography-two.svg");
  background-repeat: repeat;
  background-size: 500px 500px;
  opacity: 0.1;
}

.first-background {
  background: linear-gradient(
    180deg,
    rgba(78, 84, 200, 0.1) 0%,
    rgba(38, 41, 98, 0.1) 100%
  );
}
</style>
